import React from 'react';
import { cn } from '../../../lib/cn';

export interface DashboardPillProps {
  children: React.ReactNode;
  variant?: 'accent' | 'brass' | 'neutral';
  className?: string;
}

const VARIANTS = {
  accent: 'border-[color-mix(in_srgb,var(--ai-3)_20%,transparent)] bg-[var(--ai-tint)] text-[var(--ai-3)]',
  brass: 'border-[color-mix(in_srgb,var(--gold)_25%,transparent)] bg-[var(--gold-tint)] text-[var(--gold)]',
  neutral: 'border-[var(--cream-2)] bg-[var(--cream-1)] text-[var(--ink-2)]',
};

export function DashboardPill({ children, variant = 'accent', className }: DashboardPillProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-[var(--r-pill)] border px-2 py-0.5 text-[10.5px] font-semibold',
        VARIANTS[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
